module.exports = __webpack_public_path__ + "static/media/Ar-Arisp.3beeb8a7.png";